export default "__VITE_ASSET__f2581cd3__"